import { render, staticRenderFns } from "./ChatOrderProfileAddressPanel.vue?vue&type=template&id=6d26d4b0&scoped=true&"
import script from "./ChatOrderProfileAddressPanel.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileAddressPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProfileAddressPanel.vue?vue&type=style&index=0&id=6d26d4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d26d4b0",
  null
  
)

export default component.exports